import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { timelineEntries } from "@/models/Timeline";
export default defineComponent({
  name: "AboutView",
  data: function data() {
    return {
      timelineEntries: timelineEntries
    };
  },
  methods: {
    isMobile: function isMobile() {
      return !window.matchMedia("(min-width: 768px)").matches;
    },
    timelineClass: function timelineClass(type) {
      switch (type) {
        case "graduation":
          return "is-icon is-success";

        case "work":
          return "is-icon is-info";

        case "achievement":
          return "is-icon is-warning";

        case "relocate":
          return "is-icon is-danger";

        case "spawn":
        case "university":
        case "school":
          return "is-icon";
      }

      return "";
    },
    timelineMarkerIcon: function timelineMarkerIcon(type) {
      switch (type) {
        case "spawn":
          return "fas fa-star";

        case "school":
          return "fas fa-school";

        case "graduation":
          return "fas fa-graduation-cap";

        case "university":
          return "fas fa-university";

        case "achievement":
          return "fas fa-trophy";

        case "relocate":
          return "fas fa-plane-departure";

        case "work":
          return "fas fa-building";
      }

      return "fa fa-flag";
    }
  },
  setup: function setup() {
    return useI18n();
  }
});